// React
import React from "react";
// Components
import { KeyboardDatePicker } from "@material-ui/pickers";
import Wrapper from "../Wrapper";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

export default ({ ...rest }) => (
  <Wrapper>
    <KeyboardDatePicker {...rest} />
  </Wrapper>
);
